// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox__checkbox___A4vXf","checkbox__input":"Checkbox__checkbox__input___v7sF7","checkbox__label":"Checkbox__checkbox__label___PhlZg"};